import React from "react";
import { connect } from "react-redux";
import { withRouter, RouteComponentProps } from "react-router-dom";

import "Common.css";
import "./ManageCareRecipient.css";
import BaseElem from "BaseElem";
import CalendarView from "Components/CalendarView/CalendarView";
import { WalletDropdown } from "Components/WalletDropdown";

import {
  getCareRecipientDetails,
  getStates,
  getEntities,
} from "Actions/CareRecipientActions";
import {
  getCareRecipientPastVisitSummary,
  getCareRecipientFutureVisitSummary,
  getPreviousVisit,
  getReasons,
} from "Actions/VisitActions";
import {
  getVisitDrafts,
  getServices,
  saveNewVisitDrafts,
  setUpdateVisitsData,
  setDraftsType,
  DRAFT_TYPE_NEW,
  DRAFT_TYPE_UPDATE,
  DRAFT_TYPE_PENDING_PAYMENT,
} from "Actions/VisitDraftActions";
import { resetPricingAll } from "Actions/PricingActions";
import { parseDate, getMonthName } from "Util/DateUtils";
import {
  CR_VISIT_HISTORY,
  VISITS_BY_CR,
  CR_LIST,
  MSG_SHOW_CALENDAR_VIEW,
  MSG_REFRESH_CR_INFO,
  MSG_REFRESH_CR_DETAILS,
  UNDEF,
  API_LONG_VISITS_BY_ID,
} from "Constants";
import { TextDropdown } from "Components/TextDropdown";
import { getCOName, getName, isBlank } from "Util/Utilities";
import Api from "Api";
import { APP_COUNTRY, isMY } from "DataConstants";

const VisitDraftsListView = React.lazy(
  () => import("Components/ListView/VisitDraftsListView")
);
const VisitDialog = React.lazy(() => import("Components/Dialogs/VisitDialog"));

export function isB2b(crInfo: any) {
  //return !!(crInfo && crInfo.client_type === 'vwo' && crInfo.vwo[0]);
  return !!(
    crInfo &&
    crInfo.client_type === "vwo" &&
    crInfo.vwo &&
    crInfo.vwo[0]
  );
}

type ManageCareRecipientProps = {
  recipientStore?: any;
  visitDraftStore?: any;
  visitStore?: any;
  match: any;
  coList?: any[];
  crList?: any[];
};

type ManageCareRecipientConnectProps = {
  getCareRecipientDetails: (crId: string, coId?: string) => void;
  getCareRecipientPastVisitSummary: (_id: string) => void;
  getCareRecipientFutureVisitSummary: (_id: string) => void;
  getVisitDrafts: (_id: string) => void;
  getServicesList: () => void;
  resetPricingAll: () => void;
  getPreviousVisit: (crId: string) => void;
  saveNewVisitDrafts: (visitDrafts: any[]) => void;
  getStates: () => void;
  getEntities: (type: string) => void;
  setUpdateVisitsData: (type: any) => void;
  setDraftsType: (type: string, draftId?: string) => void;
};

export type DeeplinkParams = {
  isCancel?: boolean;
  isUpdate?: boolean;
  isUpdatePricing?: boolean;
  visitIds?: string[];
  visits?: any[];
  cancellationReason?: string;
  changeReason?: string;
  consumed?: boolean;
};

type ManageCareRecipientState = {
  details: any;
  show_list_view: boolean;
  visitDrafts: Array<object>;
  showingMore?: boolean;

  // cancel/update/update-pricing
  deeplinkParams?: DeeplinkParams;
};

type ManageCareRecipientActualProps = ManageCareRecipientProps &
  ManageCareRecipientConnectProps &
  RouteComponentProps<any>;

class ManageCareRecipient extends BaseElem<
  ManageCareRecipientActualProps,
  ManageCareRecipientState
> {
  crId = "";
  coId?: string;
  crName = "";

  constructor(props: ManageCareRecipientActualProps) {
    super(props);
    const self = this;
    self.state = {
      details: {},
      show_list_view: false,
      visitDrafts: [],
    };

    const params = props.match.params;
    self.coId = params.co_id;
    self.crId = params.id;
    self._processQueryParams();
  }

  componentWillUnmount() {
    this.unlisten(
      MSG_SHOW_CALENDAR_VIEW,
      MSG_REFRESH_CR_INFO,
      MSG_REFRESH_CR_DETAILS
    );
  }

  componentDidMount() {
    const self = this,
      props = self.props,
      crId = self.crId,
      coId = self.coId;
    props.getCareRecipientDetails(crId, coId);
    props.getCareRecipientPastVisitSummary(crId);
    props.getCareRecipientFutureVisitSummary(crId);

    self.async(() => {
      props.getPreviousVisit(crId);
      props.getServicesList();
      props.getVisitDrafts(crId);
      isMY && props.getStates();
    }, 500);

    // props.getEntities('owner');
    self.async(() => props.getEntities("recipient"), 2000);
    self.listen(
      MSG_SHOW_CALENDAR_VIEW,
      MSG_REFRESH_CR_INFO,
      MSG_REFRESH_CR_DETAILS
    );

    //TODO: remove later
    //self.async(() => self._switchToListView(UNDEF, test_visitUpdateData), 800);
    //self.post(MSG_SHOW_UPDATE_REVIEW, test_updateVisitData2, 1200);

    // self.async(() => self._switchToListView(test_visitdrafts), 800 * 0);
    /*self.async(() => {
      props.setDraftsType(DRAFT_TYPE_PENDING_PAYMENT, "pending-draft-id");
      props.saveNewVisitDrafts(test_visitdrafts);
      self._showListView();
    }, 100);*/
  }

  componentDidUpdate(_prevProps: any) {
    const w = window as any;
    const url = w.location.href;

    const recipientStore = this.props.recipientStore;
    const details = recipientStore && recipientStore.careRecipient;
    const cr = details && details.cr;
    if (cr) {
      const isb2b = isB2b(cr);
      const isB2bConfig =
        (process.env.REACT_APP_REGION || "")?.indexOf("-B2B") > 0;

      const stagingUrl = "-v2.smiley-unicorn.info";
      const b2bStagingUrl = "-b2b.smiley-unicorn.info";
      const prodUrl = "app2.homage.";
      const b2bProdUrl = "app2-b2b.homage.";

      if (isb2b && !isB2bConfig) {
        if (url.indexOf(stagingUrl) > 0) {
          w.location.href = url.replace(stagingUrl, b2bStagingUrl);
        } else if (url.indexOf(prodUrl) >= 0) {
          w.location.href = url.replace(prodUrl, b2bProdUrl);
        }
      } else if (!isb2b && isB2bConfig) {
        if (url.indexOf(b2bStagingUrl) > 0) {
          w.location.href = url.replace(b2bStagingUrl, stagingUrl);
        } else if (url.indexOf(b2bProdUrl) >= 0) {
          w.location.href = url.replace(b2bProdUrl, prodUrl);
        }
      }
    }
  }

  getRegion = () => {
    const { recipientStore } = this.props;
    const timezone = recipientStore?.careRecipient?.cr?.timezone;
    let region = timezone?.timezones?.[APP_COUNTRY];
    if (timezone?.is_single_tz === false) {
      const city = recipientStore?.careRecipient?.co?.address_list?.[0]?.city;
      region = timezone.timezones[city];
    }
    return region;
  };

  onMessage(messageName: string, _payload?: any) {
    const self = this,
      props = self.props,
      crId = self.crId,
      coId = self.coId;

    switch (messageName) {
      case MSG_SHOW_CALENDAR_VIEW:
        self._showListView(false);
        break;

      case MSG_REFRESH_CR_DETAILS:
        props.getCareRecipientDetails(crId, coId);
        break;

      case MSG_REFRESH_CR_INFO:
        props.getCareRecipientDetails(crId, coId);
        props.getCareRecipientPastVisitSummary(crId);
        props.getCareRecipientFutureVisitSummary(crId);
        props.getPreviousVisit(crId);
        props.getVisitDrafts(crId);
        break;
    }
  }

  _processQueryParams() {
    const self = this;
    // parse query parameters to deeplink
    const query = new URLSearchParams(self.props.location.search);
    const action = query.get("action");
    const visitIds = (query.get("visit_ids") || "").split(",");
    if (isBlank(visitIds)) return;

    const params: DeeplinkParams = {
      isCancel: action === "cancel",
      isUpdate: action === "update",
      isUpdatePricing: action === "update-pricing",
      visitIds: visitIds,
      cancellationReason: query.get("cancellation_reason") || UNDEF,
      changeReason: query.get("change_reason") || UNDEF,
    };

    const reqParams = "?visit_ids[]=" + visitIds.join("&visit_ids[]=");
    Api.GET(
      API_LONG_VISITS_BY_ID + reqParams,
      (resp) => {
        const visits = resp && resp.data && resp.data.visits;
        if (!visits || !visits[0]) return;

        params.visits = visits;
        self.setState({
          deeplinkParams: params,
        });
      },
      true,
      true,
      true
    );
  }

  _showListView(show = true) {
    this.setState({ show_list_view: show });
  }

  _getSavedDraftsCount() {
    const self = this,
      visitDraftStore = self.props.visitDraftStore,
      savedDrafts = visitDraftStore && visitDraftStore.savedVisitDrafts;
    return (savedDrafts && savedDrafts.length) || 0;
  }

  //Goto new CR Page
  _gotoCR(cr: any) {
    if (!cr || !cr._id) return;
    //this.setState({ crName: cr.name });
    window.location.href = "/cr/" + cr._id;
  }

  _switchToListView = (newVisits?: any[], updateVisitsData?: any) => {
    const self = this,
      props = self.props;
    if (newVisits) {
      props.saveNewVisitDrafts(newVisits);
      props.setDraftsType(DRAFT_TYPE_NEW);
    } else if (updateVisitsData) {
      props.setUpdateVisitsData(updateVisitsData);
      props.setDraftsType(DRAFT_TYPE_UPDATE);
    }
    self._showListView();
  };

  _switchToSavedDraftsListView(
    type: string,
    draftsData?: any,
    draftsId?: string
  ) {
    const self = this;
    const props = self.props;

    if (type === DRAFT_TYPE_UPDATE) {
      props.setUpdateVisitsData(draftsData);
    } else if (type === DRAFT_TYPE_PENDING_PAYMENT) {
      props.saveNewVisitDrafts(draftsData);
    }
    props.setDraftsType(type, draftsId);

    self._showListView();
  }

  _setTabTitle(name: string) {
    if (name && this.crName !== name) {
      document.title = name;
      this.crName = name;
    }
  }

  render() {
    const self = this,
      state = self.state,
      props = self.props,
      visitStore = props.visitStore,
      recipientStore = props.recipientStore;
    const details = recipientStore && recipientStore.careRecipient;
    const region = this.getRegion();
    //const locationFields = recipientStore && recipientStore.locationFields;
    if (details) {
      const { co, cr, b2b2c } = details;
      const b2b = isB2b(cr);
      const vwo = cr && cr.vwo && cr.vwo[0];
      const vwoId = (vwo && vwo._id) || UNDEF;
      const facilityGroupSize = vwo && vwo.group_size;
      const facilityGroupGender = vwo && vwo.group_gender;
      const facilityOtherInfo = vwo && vwo.other_information;
      const isFacility = facilityGroupSize || facilityGroupGender;
      const createdAt = cr.created_at;
      const haveCard = !!(co && co.wallet && co.wallet.card);

      const cos = cr && cr.care_owners;
      const coId = self.coId || (cos && cos[0] && cos[0].user_id);
      self.coId = coId;
      const crName = cr ? getName("", cr.first_name, cr.last_name) : "";
      self._setTabTitle(crName);

      return (
        <div className="manage-care-recipeint v">
          <div className="h justified">
            <span className="component-title">Manage Care Recipient</span>

            <div className="nav-links h center">
              <a href="/">
                <img src="/home.png" width="14" alt="" />
                &nbsp;&nbsp;Home
              </a>
              <img className="arrow end" src="/cal-left-arrow.svg" alt="" />
              <a href={CR_LIST}>
                <img src="/carepros.png" width="14" alt="" />
                &nbsp;&nbsp;Care Recipients
              </a>
              <img className="arrow end" src="/cal-left-arrow.svg" alt="" />
              <a href={VISITS_BY_CR(self.crId)}>Care Recipient Details</a>
            </div>
          </div>

          <div className="component-whitebox">
            {/* Top part */}
            <div className="horizontal mcr-top-section center">
              <img
                src={cr.avatar_url || "/carepro.png"}
                className="avatar round"
                alt="Care Recipient"
              />
              <div className="vertical mcr-cr-info">
                {/* <span className="mcr-cr-name">{cr.first_name + " " + cr.last_name}</span> */}

                <div className="h vc">
                  <TextDropdown
                    inputClassName="mcr-cr-inp"
                    useVirtualList
                    itemHeight={40}
                    filterSelection
                    popupWidth="270px"
                    popupMaxHeight="300px"
                    placeholder="CR or CF name"
                    idProperty="_id"
                    titleProperty="name"
                    dontAnimate
                    items={props.crList || []}
                    selectedItem={crName}
                    onChange={(_: any, cr: any) => self._gotoCR(cr)}
                  />
                  {co && (
                    <WalletDropdown
                      coId={coId}
                      haveCard={haveCard}
                      wallet={co.wallet}
                      onCardAdded={() =>
                        props.getCareRecipientDetails(self.crId, coId)
                      }
                    />
                  )}

                  {b2b2c && <img src={b2b2c.logo} alt="" height="24" />}
                </div>

                <span className="mcr-co-info">
                  {b2b ? "Organization:" : !co ? "" : "Care Owner:"}{" "}
                  <span className="co-link">{getCOName(recipientStore)}</span>
                  {b2b ? "" : !co ? "" : ", " + co.co_phone}
                  {co && co.has_agreed_to_tos === false && (
                    <div className="mcr-red">Has not agreed on TOS</div>
                  )}
                </span>

                {!facilityGroupSize && createdAt && (
                  <span className="mcr-co-info mcr-customer-since">
                    {`Customer since ${getMonthName(
                      parseDate(createdAt, true)
                    )} ${parseDate(createdAt, true).getFullYear()}`}
                  </span>
                )}

                {facilityGroupSize && (
                  <div className="h mcr-customer-since">
                    <span className="singleline ellipsis">
                      {facilityGroupSize}, {facilityGroupGender}
                    </span>
                    <span
                      className="mcr-show-more"
                      onClick={() => self.setState({ showingMore: true })}
                    >
                      &nbsp;Show more
                    </span>
                  </div>
                )}
              </div>

              {/* Tabs */}
              <div className="mcr-tabs horizontal center-justified grow">
                <div className="mcr-tab mcr-selected horizontal center hcenter no-select">
                  {/* <img width="24" src="/schedule_care.png" alt="" /> */}
                  <span>Schedule Care</span>
                </div>
                <div
                  className="mcr-tab horizontal center hcenter no-select"
                  onClick={() => {
                    window.open(
                      coId
                        ? `/careowner/${coId}/${self.crId}`
                        : CR_VISIT_HISTORY(self.crId, isFacility)
                    );
                  }}
                >
                  {/* <img width="24" src="/basic_details.png" alt="" /> */}
                  <span>Basic Details</span>
                </div>

                <div
                  className="mcr-tab horizontal center hcenter no-select"
                  onClick={() => {
                    window.open(VISITS_BY_CR(self.crId));
                  }}
                >
                  {/* <img width="24" src="/visit_history.png" alt="" /> */}
                  <span>Visit History</span>
                </div>

                <div
                  className="mcr-tab horizontal center hcenter no-select"
                  onClick={() => {
                    window.open("/priority-inbox?cr_ids=" + self.crId);
                  }}
                >
                  {/* <img width="24" src="/visit_history.png" alt="" /> */}
                  <span>Open Visits</span>
                </div>
              </div>

              {/* CR Stats */}
              <div className="horizontal center">
                <div
                  className="vertical"
                  onClick={() =>
                    window.open("/priority-inbox?cr_ids=" + self.crId)
                  }
                >
                  <span className="mcr-co-info">Upcoming</span>
                  <div className="horizontal">
                    <div className="vertical mcr-p-r">
                      <span className="mcr-count">
                        {visitStore && visitStore.futureSummary
                          ? visitStore.futureSummary.totalVisits
                          : "-"}
                      </span>
                      <span className="mcr-count-label">Visits</span>
                    </div>
                    <div className="vertical">
                      <span className="mcr-count">
                        {" "}
                        {visitStore && visitStore.futureSummary
                          ? visitStore.futureSummary.totalHours
                          : "-"}
                      </span>
                      <span className="mcr-count-label">Hours</span>
                    </div>
                  </div>
                </div>

                <div className="mcr-vline" />

                <div
                  className="vertical"
                  onClick={() =>
                    window.open(CR_VISIT_HISTORY(self.crId, isFacility))
                  }
                >
                  <span className="mcr-co-info">Completed</span>
                  <div className="horizontal">
                    <div className="vertical mcr-p-r">
                      <span className="mcr-count">
                        {visitStore && visitStore.pastSummary
                          ? visitStore.pastSummary.totalVisits
                          : "-"}
                      </span>
                      <span className="mcr-count-label">Visits</span>
                    </div>
                    <div className="vertical">
                      <span className="mcr-count">
                        {visitStore && visitStore.pastSummary
                          ? visitStore.pastSummary.totalHours
                          : "-"}
                      </span>
                      <span className="mcr-count-label">Hours</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {state.showingMore && (
              <div className="mcr-info-popup v">
                <div
                  className="mcr-bg"
                  onClick={() => self.setState({ showingMore: false })}
                />
                <span>
                  Group Size: <span>{facilityGroupSize}</span>
                </span>
                <span>
                  Group Gender: <span>{facilityGroupGender}</span>
                </span>
                <span>
                  Other Information: <span>{facilityOtherInfo}</span>
                </span>
              </div>
            )}

            <div className="mcr-hline" />
            <div className="mcr-schedule-care vertical">
              {(() => {
                if (self.state.show_list_view) {
                  return <VisitDraftsListView coId={coId} vwoId={vwoId} />;
                } else {
                  return (
                    <CalendarView
                      deeplinkParams={state.deeplinkParams}
                      draftsCount={
                        self._getSavedDraftsCount() ||
                        cr.regular_visit_drafts_count ||
                        0
                      }
                      mobileDraftsCount={cr.mobile_visit_drafts_count}
                      entDraftsCount={cr.enterprise_visit_drafts_count}
                      pendingPaymentDrafts={
                        // test_pendingPayment
                        cr.pending_payment_drafts //TODO: uncomment
                      }
                      // updateDrafts={cr.update_visit_drafts}
                      onShowListView={(
                        type: string,
                        updateVisitsData?: any,
                        draftId?: string
                      ) =>
                        self._switchToSavedDraftsListView(
                          type,
                          updateVisitsData,
                          draftId
                        )
                      }
                    />
                  );
                }
              })()}
            </div>
          </div>
          <VisitDialog
            region={region}
            // locationFields={locationFields}
            coId={coId}
            moveToListView={self._switchToListView}
          />
        </div>
      );
    } else {
      return null; //<LoadingSpinner />;
    }
  }
}

const mapStateToProps = (state: any) => {
  const { recipientStore } = state;
  return {
    ...state,
    crList: recipientStore.crList,
    coList: recipientStore.coList,
  };
};

const mapDispatchToProps = (dispatch: any) => ({
  getCareRecipientDetails: (_id: string, coId?: string) =>
    dispatch(getCareRecipientDetails(_id, coId)),
  getVisitDrafts: (_id: string) => dispatch(getVisitDrafts(_id)),
  getServicesList: () => dispatch(getServices()),
  getCareRecipientPastVisitSummary: (_id: string) =>
    dispatch(getCareRecipientPastVisitSummary(_id)),
  getCareRecipientFutureVisitSummary: (_id: string) =>
    dispatch(getCareRecipientFutureVisitSummary(_id)),
  resetPricingAll: () => dispatch(resetPricingAll()),
  getPreviousVisit: (crId: string) => dispatch(getPreviousVisit(crId)),
  saveNewVisitDrafts: (visitDrafts: any[]) =>
    dispatch(saveNewVisitDrafts(visitDrafts)),
  getStates: () => dispatch(getStates()),
  getEntities: (type: string) => dispatch(getEntities(type)),
  setUpdateVisitsData: (data: any) => dispatch(setUpdateVisitsData(data)),
  setDraftsType: (type: string, draftId?: string) =>
    dispatch(setDraftsType(type, draftId)),
  getReasons: () => dispatch(getReasons()),
});

export default withRouter(
  connect<ManageCareRecipientState, ManageCareRecipientConnectProps>(
    mapStateToProps,
    mapDispatchToProps
  )(ManageCareRecipient)
);
